import { Link } from 'react-router-dom';
import './editor.scss';

export default function Editor() {
  return (
    <main className="editor-home">
      <h1>Editor mode</h1>
      <p>Create a course outline, publish its blank pages, then edit each lesson.</p>
      <p><Link to="/editor/course/new">Create course</Link> · <Link to="/editor/course-drafts">Your course drafts</Link> · <Link to="/courses">Edit a published course</Link></p>
      <p>Get started with the <Link to="/editor/doc/editor/markup">Markup Documentation</Link> to learn how to write lessons.</p>
    </main>
  );
}
